import { GET_ANNOUNCEMENTS_SEVERITY, GET_EDIT_ANNOUNCEMENT_ROLE_ARRAY, GET_ANNOUNCEMENT_DIALOG_STATE } from '../getter-types'
import {
  EDIT_ANNOUNCEMENT,
  SET_EDIT_ANNOUNCEMENT_MESSAGE,
  SET_ALL_ANNOUNCEMENTS,
  SET_ANNOUNCEMENTS,
  SET_EDIT_ANNOUNCEMENT_END_DATE,
  SET_EDIT_ANNOUNCEMENT_ROLES,
  SET_EDIT_ANNOUNCEMENT_SEVERITY,
  SET_EDIT_ANNOUNCEMENT_START_DATE,
  SET_INFORMATION_SNACKBAR_STATE,
  SET_INFORMATION_SNACKBAR_TEXT,
  SET_ANNOUNCEMENT_DIALOG_STATE,
  SET_ANNOUNCEMENT_DIALOG_STATE_VISIBLITY,
  SET_ANNOUNCEMENT_FORM_VALID,
  SAVE_DELETED_ANNOUNCEMENT_ID,
  SET_UNDO_TYPE
} from '../mutation-types'
import {
  FETCH_ALL_ANNOUNCEMENTS,
  FETCH_USER_ANNOUNCEMENTS,
  SAVE_EDIT_ANNOUNCEMENT,
  SAVE_NEW_ANNOUNCEMENT,
  TOGGLE_ADMIN_ANNOUNCEMENT,
  DELETE_ANNOUNCEMENT,
  SET_UNDO_STATE_ASYNC
} from '../action-types'
import axios from 'axios'
import { informationTexts } from './information'
import { undoTypes } from './undo'
import server from '../server'
import moment from 'moment-es6'

const state = {
  announcements: [],
  allAnnouncements: [],
  editAnnouncement: {
    message: '',
    role: '',
    severity: '',
    enabled: true,
    fromDate: moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD')
  },
  announcementDialogState: {},
  lastDeletedId: null,
  valid: true,

  defaultAnnouncement: {
    message: '',
    role: '',
    severity: '',
    enabled: true,
    fromDate: moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD')
  }
}

const mutations = {
  [SET_ANNOUNCEMENTS] (state, announcements) {
    state.announcements = announcements
  },
  [SET_ALL_ANNOUNCEMENTS] (state, announcements) {
    state.allAnnouncements = announcements
  },
  [EDIT_ANNOUNCEMENT] (state, announcement) {
    state.editAnnouncement = Object.assign({}, announcement)
  },
  [SET_EDIT_ANNOUNCEMENT_MESSAGE] (state, message) {
    state.editAnnouncement.message = message
  },
  [SET_EDIT_ANNOUNCEMENT_ROLES] (state, roles) {
    state.editAnnouncement.role = roles.toString()
  },
  [SET_EDIT_ANNOUNCEMENT_SEVERITY] (state, severity) {
    state.editAnnouncement.severity = severity
  },
  [SET_EDIT_ANNOUNCEMENT_START_DATE] (state, startDate) {
    state.editAnnouncement.fromDate = startDate.start
  },
  [SET_EDIT_ANNOUNCEMENT_END_DATE] (state, endDate) {
    state.editAnnouncement.toDate = endDate.end
  },
  [SET_ANNOUNCEMENT_DIALOG_STATE] (state, value) {
    state.announcementDialogState = value
  },
  [SET_ANNOUNCEMENT_DIALOG_STATE_VISIBLITY] (state, value) {
    state.announcementDialogState.visible = value
  },
  [SAVE_DELETED_ANNOUNCEMENT_ID] (state, id) {
    state.lastDeletedId = id
  },
  [SET_ANNOUNCEMENT_FORM_VALID] (state, isValid) {
    state.valid = isValid
  }
}
const actions = {
  [FETCH_USER_ANNOUNCEMENTS] ({commit, rootState}) {
    server.getReplayable('/core/messages', {action: FETCH_USER_ANNOUNCEMENTS})
    .then(res => {
      commit(SET_ANNOUNCEMENTS, res.data)
    }).catch(err => {
      console.error(err)
    })
  },
  [FETCH_ALL_ANNOUNCEMENTS] ({commit, rootState}) {
    server.getReplayable('/core/messages/all', {action: FETCH_ALL_ANNOUNCEMENTS})
    .then(res => {
      commit(SET_ALL_ANNOUNCEMENTS, res.data)
    }).catch(err => {
      console.error(err)
    })
  },
  [TOGGLE_ADMIN_ANNOUNCEMENT] ({commit, rootState, state, dispatch}, announcement) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/messages/${announcement.id}/status`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: { action: TOGGLE_ADMIN_ANNOUNCEMENT, data: announcement },
      params: {
        status: !announcement.enabled
      }
    }).then(res => {
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ANNOUNCEMENT_STATUS_UPDATED)
      dispatch(FETCH_USER_ANNOUNCEMENTS)
      dispatch(FETCH_ALL_ANNOUNCEMENTS)
    }).catch(err => {
      console.error(err)
    })
  },
  [SAVE_NEW_ANNOUNCEMENT] ({commit, rootState, state, dispatch}) {
    return axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/messages/`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: state.editAnnouncement,
      actionData: { action: SAVE_NEW_ANNOUNCEMENT, data: state.editAnnouncement }
    }).then(res => {
      dispatch(FETCH_ALL_ANNOUNCEMENTS)
      dispatch(FETCH_USER_ANNOUNCEMENTS)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ANNOUNCEMENT_CREATED)
      commit(SET_ANNOUNCEMENT_DIALOG_STATE, {})
    }).catch(err => {
      console.error(err)
    })
  },
  [SAVE_EDIT_ANNOUNCEMENT] ({commit, rootState, state, dispatch}) {
    return axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/messages/${state.editAnnouncement.id}/`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: state.editAnnouncement,
      actionData: { action: SAVE_EDIT_ANNOUNCEMENT, data: state.editAnnouncement }
    }).then(res => {
      dispatch(FETCH_ALL_ANNOUNCEMENTS)
      dispatch(FETCH_USER_ANNOUNCEMENTS)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ANNOUNCEMENT_UPDATED)
      commit(SET_ANNOUNCEMENT_DIALOG_STATE, {})
    }).catch(err => {
      console.error(err)
    })
  },
  [DELETE_ANNOUNCEMENT] ({commit, rootState, dispatch}, payload) {
    return axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/messages/${payload.id}/delete/${payload.delete}`,
      method: 'delete',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: { action: DELETE_ANNOUNCEMENT, data: payload }
    }).then((res) => {
      if (payload.delete) {
        dispatch(SET_UNDO_STATE_ASYNC, true)
        commit(SAVE_DELETED_ANNOUNCEMENT_ID, payload.id)
        commit(SET_UNDO_TYPE, undoTypes.ANNOUNCEMENT_DELETION)
      } else {
        dispatch(SET_UNDO_STATE_ASYNC, false)
      }
      dispatch(FETCH_ALL_ANNOUNCEMENTS)
      dispatch(FETCH_USER_ANNOUNCEMENTS)
    })
    .catch((err) => {
      if (payload.delete) {
        console.log('Failed to delete announcement')
        console.error(err)
      } else {
        console.log('Failed to undo deletion of announcement')
        console.error(err)
      }
    })
  }
}
const getters = {
  [GET_ANNOUNCEMENTS_SEVERITY]: state => {
    let temp = null
    let tempNumber = -1
    state.announcements.forEach(item => {
      if (tempNumber < SERVERITY_WEIGHT[item.severity]) {
        temp = item.severity
        tempNumber = SERVERITY_WEIGHT[item.severity]
      }
    })
    return temp
  },
  [GET_EDIT_ANNOUNCEMENT_ROLE_ARRAY]: state => {
    if (state.editAnnouncement.role) {
      return state.editAnnouncement.role.split(',')
    }
    return []
  },
  [GET_ANNOUNCEMENT_DIALOG_STATE]: state => {
    return state.announcementDialogState
  }
}

const SERVERITY_WEIGHT = {
  INFO: 0,
  WARNING: 1,
  ERROR: 2,
  CRITICAL: 3
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/announcement.js